var render, staticRenderFns
import script from "./EditTable.vue?vue&type=script&lang=ts&"
export * from "./EditTable.vue?vue&type=script&lang=ts&"
import style0 from "./EditTable.vue?vue&type=style&index=0&id=626b06e8&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports